export const version = 'berater-v1.19.0-SNAPSHOT-edf5c07ab867767bdbcb4ec555a96acb59bfc60b';